export const SECURITY_UI_TEXT = {
  ja: {
    securityPageDescription: 'Passkey、登録メール、認証アプリ、Backup Code、ログイン中の端末を管理します。',
    loadFailed: 'セキュリティ情報を取得できませんでした。',
    retry: '再試行',
    passkeyDescription: '指紋・顔認証・端末のPINなど、端末のロック解除方法でログインできます。',
    addPasskey: 'Passkeyを追加',
    twoFactorDescription: '2段階認証では、Accountに登録済みのメールまたは認証アプリの確認コードを選んで認証できます。',
    twoFactorToggle: '2段階認証を使用',
    turnOffTwoFactor: '2段階認証をOFFにする',
    emailMethod: 'メール',
    emailMethodDescription: 'Astera Accountに登録済みのメールアドレスへ確認コードを送信します。',
    emailReady: '利用可能',
    emailNeedsSetup: '登録・確認が必要',
    manageEmail: 'Accountでメールを登録・変更',
    authenticatorMethod: '認証アプリ',
    authenticatorDescription: 'QRコードを読み取って認証アプリを登録します。',
    authenticatorReady: '登録済み',
    authenticatorNotReady: '未登録',
    setupTwoFactor: '認証アプリを設定',
    confirmIdentity: '本人確認',
    confirmIdentityDescription: '認証アプリのQRコードを表示するため、Account登録時のAstera用Passwordを入力してください。',
    cancel: 'キャンセル',
    scanTitle: 'QRコードを読み取る',
    scanDescription: '認証アプリを開き、このQRコードを読み取ってください。',
    qrLoading: 'QRコードを作成しています…',
    manualSetup: 'QRコードを読み取れない場合',
    setupKey: 'セットアップキー',
    copyKey: 'キーをコピー',
    keyCopied: 'セットアップキーをコピーしました。',
    codeTitle: '6桁のコードを入力',
    manageTwoFactor: '2段階認証を管理',
    signedInDevices: 'ログイン中の端末',
    signedInDevicesDescription: '現在Asteraへログインしている端末です。心当たりのない端末はログアウトできます。',
    devicesUnavailable: '有効なSession情報を取得できませんでした。再Login後にこのPageを再読み込みしてください。',
    lastUsed: '最終利用',
    signOutDevice: 'ログアウト',
    deviceSignedOut: '選択した端末をログアウトしました。',
    deviceSignOutFailed: '選択した端末をログアウトできませんでした。',
    passkeyCreated: '登録日時',
    passkeyStorage: '保存方式',
    passkeyBackup: '同期・Backup',
    passkeyAuthMethod: '認証方式',
    passkeyBackedUp: 'Backup / 同期済み',
    passkeyNotBackedUp: '未Backup',
    device: '端末',
    thisDevice: 'この端末',
    syncPasskey: '同期Passkey',
    devicePasskey: '端末Passkey',
    syncCapablePasskey: '同期可能なPasskey',
    singleAuthenticator: '1つの認証器に保存',
    passkeyStorageFallback: 'Passkey保存先',
    deviceAuthenticator: '端末の認証器',
    builtInAuthenticator: '端末内認証',
    crossDevice: '別端末連携',
    twoFactorLoginDescription: '認証方法を選んでLoginを完了します。',
    methodTitle: '認証方法',
    methodDescription: 'メールまたは認証アプリから使用する方法を選択してください。',
    authenticatorLogin: '認証アプリ',
    authenticatorLoginDescription: '認証アプリに表示された6桁コードを使用します。',
    emailLogin: 'メール',
    emailLoginDescription: 'Accountに登録済みのメールへ確認コードを送信します。',
    emailSendDescription: '別のメール登録は不要です。Accountに登録済みのメールアドレスを使用します。',
    sendEmailCode: 'メールで確認コードを受け取る',
    resendEmailCode: '確認コードを再送',
    emailCodeSent: 'Account登録メールへ確認コードを送信しました。',
    emailCodeLabel: 'メールに届いた確認コード',
    authenticatorCodeLabel: '認証アプリの確認コード',
    verifyLogin: '認証してLogin',
    twoFactorComplete: '2段階認証が完了しました。',
    processing: '処理しています…',
    emergencyTitle: '非常用',
    emergencyDescription: '通常の認証方法を利用できない場合のみ使用してください。',
    useBackupCode: 'Backup Codeを使う',
    backupCodeLabel: 'Backup Code',
    verifyBackupCode: 'Backup Codeで認証',
    backupCodeComplete: 'Backup Codeで認証しました。',
  },
  en: {
    securityPageDescription: 'Manage passkeys, account email, authenticator apps, backup codes, and signed-in devices.',
    loadFailed: 'Security information could not be loaded.',
    retry: 'Retry',
    passkeyDescription: 'Sign in with your device unlock method such as fingerprint, face, or PIN.',
    addPasskey: 'Add passkey',
    twoFactorDescription: 'Choose your verified account email or authenticator app when two-factor authentication is required.',
    twoFactorToggle: 'Use two-factor authentication',
    turnOffTwoFactor: 'Turn off two-factor authentication',
    emailMethod: 'Email',
    emailMethodDescription: 'Verification codes are sent to the email registered with your Astera account.',
    emailReady: 'Available',
    emailNeedsSetup: 'Registration or verification required',
    manageEmail: 'Manage email in Account',
    authenticatorMethod: 'Authenticator app',
    authenticatorDescription: 'Register an authenticator app by scanning the QR code.',
    authenticatorReady: 'Registered',
    authenticatorNotReady: 'Not registered',
    setupTwoFactor: 'Set up authenticator',
    confirmIdentity: 'Confirm your identity',
    confirmIdentityDescription: 'Enter the Astera password registered with your account to display the authenticator QR code.',
    cancel: 'Cancel',
    scanTitle: 'Scan the QR code',
    scanDescription: 'Open your authenticator app and scan this QR code.',
    qrLoading: 'Creating QR code…',
    manualSetup: 'Can’t scan the QR code?',
    setupKey: 'Setup key',
    copyKey: 'Copy key',
    keyCopied: 'Setup key copied.',
    codeTitle: 'Enter the 6-digit code',
    manageTwoFactor: 'Manage two-factor authentication',
    signedInDevices: 'Signed-in devices',
    signedInDevicesDescription: 'Devices with an active Astera session. Sign out devices you do not recognize.',
    devicesUnavailable: 'No active session information was returned. Reload this page after signing in again.',
    lastUsed: 'Last used',
    signOutDevice: 'Sign out',
    deviceSignedOut: 'The selected device has been signed out.',
    deviceSignOutFailed: 'The selected device could not be signed out.',
    passkeyCreated: 'Registered',
    passkeyStorage: 'Storage',
    passkeyBackup: 'Backup',
    passkeyAuthMethod: 'Authentication',
    passkeyBackedUp: 'Backed up / synced',
    passkeyNotBackedUp: 'Not backed up',
    device: 'Device',
    thisDevice: 'This device',
    syncPasskey: 'Synced passkey',
    devicePasskey: 'Device passkey',
    syncCapablePasskey: 'Sync-capable passkey',
    singleAuthenticator: 'Stored on one authenticator',
    passkeyStorageFallback: 'Passkey storage',
    deviceAuthenticator: 'Device authenticator',
    builtInAuthenticator: 'Built-in authenticator',
    crossDevice: 'Cross-device',
    twoFactorLoginDescription: 'Choose an authentication method to complete sign-in.',
    methodTitle: 'Authentication method',
    methodDescription: 'Choose email or your authenticator app.',
    authenticatorLogin: 'Authenticator app',
    authenticatorLoginDescription: 'Use the 6-digit code shown by your authenticator app.',
    emailLogin: 'Email',
    emailLoginDescription: 'Send a verification code to the email registered with your Account.',
    emailSendDescription: 'No separate email is required. Astera uses the email already registered with your Account.',
    sendEmailCode: 'Send verification code by email',
    resendEmailCode: 'Resend verification code',
    emailCodeSent: 'A verification code was sent to your registered Account email.',
    emailCodeLabel: 'Verification code from email',
    authenticatorCodeLabel: 'Authenticator code',
    verifyLogin: 'Verify and sign in',
    twoFactorComplete: 'Two-factor authentication completed.',
    processing: 'Processing…',
    emergencyTitle: 'Recovery',
    emergencyDescription: 'Use this only when your normal authentication methods are unavailable.',
    useBackupCode: 'Use a backup code',
    backupCodeLabel: 'Backup code',
    verifyBackupCode: 'Verify with backup code',
    backupCodeComplete: 'Authenticated with a backup code.',
  },
} as const;

export type SecurityUiLanguage = keyof typeof SECURITY_UI_TEXT;
export type SecurityUiCopy = (typeof SECURITY_UI_TEXT)[SecurityUiLanguage];

export function securityUiText(language: string): SecurityUiCopy {
  return language === 'en' ? SECURITY_UI_TEXT.en : SECURITY_UI_TEXT.ja;
}
